import { render, staticRenderFns } from "./editEmailTemplateModal.vue?vue&type=template&id=680549dd"
import script from "./editEmailTemplateModal.vue?vue&type=script&lang=js"
export * from "./editEmailTemplateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports